import { Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import FormTextEditor from "../../../../../components/UI/TextEditor/FormTextEditor";
import {
  FormInput,
  ISelectType,
  useFetch,
  useFormContext,
} from "@4uhub/lib4uhub";
import { useCallback, useEffect, useMemo, useState } from "react";
import { listTemplateGeneralMacros } from "../../../../../services/templateGeneralMacro.service";
import { useWatch } from "react-hook-form";
import { TTemplateGeneralsForm } from "./templateGeneralSchema";
import { cleanInputHtml } from "../../../../../utils/cleanInputHtml";

const translationPath = "chatBot.page.automations.templateGeneral.";

const ContentFooter = () => {
  const { t } = useTranslation();

  const [options, setOptions] = useState<ISelectType[]>([]);

  const { sendRequest } = useFetch(listTemplateGeneralMacros);

  const { control } = useFormContext<TTemplateGeneralsForm>();

  const templateGeneralType = useWatch({
    control,
    name: "templateGeneralType",
  });

  const useHtml = useWatch({
    control,
    name: "useHtml",
  });

  const fetchVariablesHandler = useCallback(async () => {
    if (templateGeneralType === null || templateGeneralType === undefined)
      return;
    const { data, success } = await sendRequest({
      TemplateGeneralTypeCode: templateGeneralType.code,
    });

    if (data && success) {
      setOptions(data);
    }
  }, [sendRequest, templateGeneralType]);

  useEffect(() => {
    fetchVariablesHandler();
  }, [fetchVariablesHandler]);

  const editorVariables = useMemo(
    () =>
      (options || []).map((option) => {
        const rawName = String(option?.name ?? "");
        const normalizedCode = rawName.replace(/[{}]/g, "").trim();

        return {
          name: rawName,
          code: normalizedCode,
        };
      }),
    [options],
  );

  return (
    <>
      <Grid item xs={12} marginBottom={2}>
        <Typography variant="body2" fontSize={18}>
          {t(translationPath + "content_footer") || "Footer"}
        </Typography>
      </Grid>

      {useHtml && (
        <Grid item xs={12}>
          <FormInput
            size="small"
            name="contentFooter"
            fullWidth
            inputProps={{
              onChange: (e) => {
                const cleaned = cleanInputHtml(e.currentTarget.value);
                e.currentTarget.value = cleaned;
              },
            }}
            label={
              t(translationPath + "insert_html", {
                section_name: t(
                  translationPath + "content_footer",
                ).toLowerCase(),
              }) || "Insert the html"
            }
            multiline
            minRows={4}
          />
        </Grid>
      )}

      {!useHtml && (
        <Grid item xs={12} sm={12} alignItems={"start"}>
          <FormTextEditor
            name="contentFooter"
            maxWidth="650px"
            variables={
              templateGeneralType === null || templateGeneralType === undefined
                ? []
                : editorVariables
            }
            menuBarProps={{
              textFormatting: true,
              tableFormatting: true,
              textAlign: true,
              markFormatting: true,
              fontSize: true,
              linkFormatting: true,
              selectColor: true,
              addImage: true,
              addImageFromUpload: true,
            }}
          />
        </Grid>
      )}
    </>
  );
};

export default ContentFooter;
